{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              48.838514502816366,
              -60.915159547251235
            ],
            [
              -135.79391818533466,
              -60.915159547251235
            ],
            [
              -135.79391818533466,
              -83.86237464071647
            ],
            [
              48.838514502816366,
              -83.86237464071647
            ],
            [
              48.838514502816366,
              -60.915159547251235
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}